import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../repeat/Header";
import Footer from "../repeat/Footer";
import EceData from "./DepData/eceData";
import "./style.css"; 
import Navigation from "./navigation";
import Lab1 from "../images/ecelab1.jpg";
import Lab2 from '../images/ecelab2.jpg';
import Lab3 from '../images/ecelab3.jpg';
import Lab4 from '../images/ecelab4.jpg';
import Lab5 from '../images/ecelab5.jpg';
import cse from "../home/departments/Computer Departmet.jpg";
import ece from "../home/departments/ECE Department.jpg";
import eee from "../home/departments/EEE Department.jpg";
import mech from "../home/departments/Mech Department.jpg";
import general from "../home/departments/General Department1.jpg";


const Cse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the backend
    fetch("https://gptkpm.in/backend/admin/ece-dept-img.php")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setData(data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const navigate = useNavigate();
    const handleNavigation = (path) => {
      navigate(path);
    };

  return (
    <div className="cse-container">
      <Header />
      <Navigation />
      <EceData />
      <div className="notebook-container">
        <div className="notebook">
          <div className="page vision-page">
            <h2 className="page-title">Vision of the department: </h2>
            <p style={{ lineHeight: "30px" }}>
            To envisage the upliftment of students in rural areas through effective teaching learning process with technical, analytical, managerial skills and professional ethics.            </p>
          </div>
          <div className="page mission-page">
            <h2 className="page-title">Mission of the department:</h2>
            <ul style={{ listStyle: "none", lineHeight: "40px" }}>
              <li>M1:-To provide a classy learning environment that caters to local and global technological and social requirements.
              </li>
              <li>M2:-To promote industry-Institute and Institute-Institute linkages for sustainable development of academic ,training and placement activities.
              </li>
              <li>M3:-To promote professional skills, ethical and spiritual values resulting in service to the community.
              </li>
              <li>M4:-To nurture a good Eco system that encourages faculty and students to engage in interdisciplinary projects.
              </li>
            </ul>
          </div>
          <div className="page program-objectives-page">
            <h2 className="page-title">Program Educational Objectives</h2>
            <ul>
              <li>PEO1 The students will have successful careers in core engineering and the allied fields. </li>
              <li>PEO2 Engage in lifelong learning to remain update in their profession and be leaders in the technological society.</li>
              <li>PEO3 Students will practice ethical values thus fulfil their responsibilities and service towards the society.</li>
            </ul>
          </div>
          <div className="page program-objectives-page">
      <h2 class="page-title">Program Outcomes</h2>
      <ul>
        <li>P01: Basic and discipline-specific knowledge:
        Apply knowledge of basic mathematics, science, engineering fundamentals, and an engineering specialization to solve engineering problems.</li>
        <li>P02: Problem Analysis:
        Identify and analyze well-defined engineering problems using codified standard methods.</li>
        <li>P03: Design/development of solutions:
        Design solutions for well-defined technical problems and assist with the design of systems components or processes to meet specified needs.</li>
        <li>PO4: Engineering tools, experimentation, and testing:
        Apply modern engineering tools and appropriate techniques to conduct standard tests and measurements.</li>
        <li>PO5: Engineering practices for society, sustainability, and environment:
        Apply appropriate technology in the context of society, sustainability, environment, and ethical practices.</li>
        <li>P06: Project management:
        Use engineering management principles individually, as a team member, or as a leader to manage projects and effectively communicate about well-defined engineering activities.</li>
        <li>P07:Life-long learning:
        Ability to analyze individual needs and engage in updating in the context of technological changes.</li>
      </ul>
    </div>
          <div class="page program-outcomes-page">
            <h2 class="page-title">Program Specific Outcomes</h2>
            <ul>
              <li>PSO1: Apply basic knowledge related to electronic devices & circuits, communication engineering and embedded systems to solve engineering problems</li>
              <li>PSO2: Excellent adaptability to changing work environment, good interpersonal skills as a leader in a team in appreciation of professional ethics and societal responsibilities.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="sec-2">
        <h3 className="section-title">Staff Members/ Faculty</h3>
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          <div className="staff-grid">
            {data.map((item) => (
              <div key={item.id} className="staff-card">
                <img
                  src={item.image}
                  alt='ECE'
                  className="staff-image"
                />
                <div className="staff-detail">
                  <h2 className="staff-name">Name: {item.name}</h2>
                  <p className="staff-profession">
                    Profession: {item.profession}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="sec-3">
        <h2>Labs</h2>
        <div id="lab">
          <div className="lab-item">
            <img src={Lab1} alt="Lab 1" />
            <p className="lab-name">CIRCUTS LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab2} alt="Lab 2" />
            <p className="lab-name">DIGITAL ELECTRONICS LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab3} alt="Lab 3" />
            <p className="lab-name">MICROCONTROLLERS LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab4} alt="Lab 4" />
            <p className="lab-name">COMPUTER LAB</p>
          </div>
          <div className="lab-item">
            <img src={Lab5} alt="Lab 5" />
            <p className="lab-name">ELECTRONIC DEVIES LAB</p>
          </div>
        </div>
      </div>
<div id="part-5">
              <div id="part-5-left">
                <h2>Departments</h2>
                <p>Here is a list of all the departments in the college</p>
              </div>
              <div id="part-5-right" className="horizontal-scroll-container">
                <div className="img-dept">
                  <img src={cse} alt="DCME Department" />
                  <button onClick={() => handleNavigation("/cse")}>DCME</button>
                </div>
                <div className="img-dept">
                  <img src={ece} alt="DECE Department" />
                  <button onClick={() => handleNavigation("/Ece")}>DECE</button>
                </div>
                <div className="img-dept">
                  <img src={eee} alt="DEEE Department" />
                  <button onClick={() => handleNavigation("/Eee")}>DEEE</button>
                </div>
                <div className="img-dept">
                  <img src={mech} alt="DME Department" />
                  <button onClick={() => handleNavigation("/Mech")}>DME</button>
                </div>
                <div className="img-dept">
                  <img src={general} alt="General Department" />
                  <button onClick={() => handleNavigation("/General")}>General</button>
                </div>
              </div>
            </div>  
      
      <Footer />
    </div>
  );
};

export default Cse;
